import { memo } from 'react';
import { Typography } from 'antd';
import styles from './Title.module.css';

interface TitleProps {
  title: string;
  subtitle?: {
    emphasis: string;
    normal: string;
  };
}

function Title({ title, subtitle }: TitleProps) {
  return (
    <>
      <Typography.Title level={1} className={`${styles.title}`}>
        {title}
      </Typography.Title>
      {subtitle && (
        <Typography.Title level={3} className={`${styles.subtitle}`}>
          {subtitle.emphasis}
          <span className={styles.normal}>{subtitle.normal}</span>
        </Typography.Title>
      )}
    </>
  );
}

export default memo(Title);
